import { Swiper } from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';

// Registers window.wwPrepareImages for the contact form's photo upload.
import './prepareImages';


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll<HTMLElement>('[data-swiper]').forEach((el) => {
    let cfg = {};
    try {
      cfg = JSON.parse(el.getAttribute('data-signals') || '{}');
    } catch (e) {
      console.error('Invalid JSON in data-signals');
    }

    new Swiper(el, {
      modules: [Navigation, Scrollbar],
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
      scrollbar: {
        el: el.querySelector('.swiper-scrollbar'),
        draggable: true,
      },
      ...cfg,
    });
  });
});
